import { useMemo } from "react";
import { collection, query, orderBy } from "firebase/firestore";
import { db } from "../lib/firebase";
import { useFirestoreCollectionOnce } from "./useFirestoreCollectionOnce";
import type { Person } from "@event-planner/shared";

/**
 * Fetches every `persons` doc (one-time). Replaces the legacy
 * `useAllUsers` + `useAllContacts` pair: under ADR-136 a single
 * `persons` collection covers both claimed (`authUid != null`) and
 * unclaimed (`authUid == null`) people.
 */
export function useAllPersons() {
  const q = useMemo(
    () => query(collection(db, "persons"), orderBy("lastName", "asc")),
    [],
  );
  return useFirestoreCollectionOnce<Person>(q);
}
